import 'style/font.css'
import 'style/global.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from 'App'
import { SnackbarProvider } from 'notistack'
import { AuthProvider } from 'providers/auth'
import { UserDeviceInfoProvider } from 'providers/user-device-info'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

const root = ReactDOM.createRoot(document.querySelector('#root') as HTMLElement)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
  },
})

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <UserDeviceInfoProvider>
        <SnackbarProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </SnackbarProvider>
      </UserDeviceInfoProvider>
    </BrowserRouter>
  </QueryClientProvider>,
)
